<script context="module">
    
</script>
<script>
    import { onMount, onDestroy } from "svelte";
    import { Statistic, initStatistic, Text, Dropdown } from "svantic";
    initStatistic()

    import { PlayingCard } from "../../../playingcard";
    import { LastBet } from "../../../../stores";
    let bet
    
    let unsubscribe = LastBet.subscribe((val) =>{
        if( val.game == "videopoker")
            bet = val
    })

    onDestroy(unsubscribe)
   // $: console.log(bet)

</script>

<div class="display-container">
    {#key bet}
    <div>
        {#if bet?.result}
            {#each bet.result.playerHand as card,i (i)}
                <PlayingCard {...card} noFlip={true}></PlayingCard>
            {/each}
        {/if}
       
    </div>
    <Statistic size="small" inverted>
        <Statistic.Label><Text class="medium">Result: </Text></Statistic.Label>
        <Statistic.Value text={true}>          
             {(bet?.result) ? bet.result.handResult : ""}
        </Statistic.Value>
       
    </Statistic>
    {/key}
</div>

<style>

.display-container {
        width: fit-content;
        margin: auto;
      
    }

</style>
